import * as React from "react";
import { useTrackCoverEdited } from "./useTracking";
import { getQuestionSetAnswers } from "../getQuestionSetAnswers";
import { useCoverSummaryProcess } from "./useCoverSummaryProcess";
import { CoverSectionQuestionSet } from "./CoverSectionQuestionSet";

type TCoverSummaryFlowProps = {
  riskProfileId: TRiskProfile["id"];
  coverSection: TCoverSection;
  disabled: boolean;
  editable: boolean;
};

export function CoverSummaryFlow(props: TCoverSummaryFlowProps) {
  const { riskProfileId, coverSection, disabled, editable = true } = props;
  const [questionSet = {}, answerEnquiry, riskData, { loading, saving }] =
    useCoverSummaryProcess({ riskProfileId, coverId: coverSection.id });
  const trackCoverEdited = useTrackCoverEdited();
  const initialValues = getQuestionSetAnswers(questionSet, riskData);
  const handleSubmit = (answers: object) => {
    answerEnquiry(answers);
    trackCoverEdited({
      questionSet,
      answers,
      cover: coverSection,
      riskData,
      riskProfileId,
      initialValues,
    });
  };
  return (
    <CoverSectionQuestionSet
      questionSet={questionSet}
      initialValues={initialValues}
      onSubmit={editable ? handleSubmit : null}
      key={questionSet?.id}
      disabled={disabled || loading || saving}
    />
  );
}
